import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreatedFolderFragment = { __typename?: 'FolderAsset', id: string, assetType: Types.AssetTypeEnum, name: string, insertedAt: string, itemCount?: number | null, matchingChildren?: { __typename?: 'MatchingAssets', totalCount: number, totalCountFolders: number, nodes: Array<{ __typename?: 'AudioAsset', id: string } | { __typename?: 'DocumentAsset', id: string } | { __typename?: 'FileAsset', id: string } | { __typename?: 'FolderAsset', id: string } | { __typename?: 'ImageAsset', id: string } | { __typename?: 'InteractiveAsset', id: string } | { __typename?: 'InteractiveLiveAsset', id: string } | { __typename?: 'ModelAsset', id: string } | { __typename?: 'UnsupportedAsset', id: string } | { __typename?: 'VersionStackAsset', id: string } | { __typename?: 'VideoAsset', id: string }>, pageInfo: { __typename?: 'PageInfo', endOffset?: number | null, startOffset?: number | null } } | null, creator: { __typename?: 'AuthenticatedUser', id: string, name?: string | null }, parent?: { __typename?: 'AudioAsset', id: string } | { __typename?: 'DocumentAsset', id: string } | { __typename?: 'FileAsset', id: string } | { __typename?: 'FolderAsset', id: string } | { __typename?: 'ImageAsset', id: string } | { __typename?: 'InteractiveAsset', id: string } | { __typename?: 'InteractiveLiveAsset', id: string } | { __typename?: 'ModelAsset', id: string } | { __typename?: 'UnsupportedAsset', id: string } | { __typename?: 'VersionStackAsset', id: string } | { __typename?: 'VideoAsset', id: string } | null, project?: { __typename?: 'Project', id: string } | null };

export const CreatedFolder = /*#__PURE__*/ gql`
    fragment CreatedFolder on FolderAsset {
  id
  assetType
  name
  insertedAt
  itemCount
  creator {
    id
    name
  }
  parent {
    id
  }
  project {
    id
  }
  ... on FolderAsset {
    matchingChildren(
      filters: []
      flattenFolders: false
      groupBys: []
      page: {afterOffset: 0, first: 3, mode: OFFSET}
      sortBys: []
    ) {
      nodes {
        id
      }
      totalCount
      totalCountFolders
      pageInfo {
        endOffset
        startOffset
      }
    }
  }
}
    ` as unknown as DocumentNode<CreatedFolderFragment, unknown>;

        

        
export const useCreatedFolderFragment = (
  input: string | Omit<UseFragmentOptions<CreatedFolderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<CreatedFolderFragment>({
    fragment: CreatedFolder,
    fragmentName: 'CreatedFolder',
    ...options,
  });
};
  
        